import React from "react";
import { Boxes, Cloud, Sparkles } from "lucide-react";
import Reveal from "./Reveal";
import { useLanguage } from "../i18n/LanguageContext";

const ICONS = [Boxes, Cloud, Sparkles];

export default function Difference() {
  const { t } = useLanguage();
  const d = t.difference;

  return (
    <section id="difference" data-testid="difference-section" className="py-24 sm:py-32 border-t border-line bg-white">
      <div className="shell">
        <div className="max-w-[720px]">
          <Reveal className="inline-flex items-center gap-2 rounded-full border border-line bg-paper px-3 py-1.5">
            <span className="live-dot" />
            <span className="kicker text-textsoft">{d.badge}</span>
          </Reveal>
          <Reveal as="h2" delay={1} className="mt-5 font-display text-[32px] sm:text-[42px] lg:text-[46px] font-semibold text-ink tracking-tight leading-[1.08]">
            {d.h2}
          </Reveal>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-5">
          {d.cards.map((card, i) => {
            const Icon = ICONS[i] || Boxes;
            const isAI = i === 2;
            if (isAI) {
              return (
                <Reveal delay={3} key={card.t} className="glow grad-border relative rounded-2xl p-8 text-white overflow-hidden" style={{ background: "linear-gradient(165deg, #163A5C 0%, #0F2A47 65%)" }}>
                  <div aria-hidden="true" className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(60% 50% at 80% 0%, rgba(63,158,114,0.22), transparent 60%)" }} />
                  <div className="relative">
                    <div className="flex items-center justify-between">
                      <span className="inline-flex w-11 h-11 items-center justify-center rounded-xl bg-white/[0.08] text-green">
                        <Icon size={20} strokeWidth={1.7} />
                      </span>
                      <span className="inline-flex items-center rounded-full bg-green/15 border border-green/30 px-2.5 py-1 font-mono text-[9px] font-semibold uppercase tracking-[0.14em] text-green">
                        {card.badge}
                      </span>
                    </div>
                    <h3 className="mt-6 font-display text-[19px] font-semibold tracking-tight">{card.t}</h3>
                    <p className="mt-2.5 text-[14px] text-white/65 leading-[1.65]">{card.b}</p>
                  </div>
                </Reveal>
              );
            }
            return (
              <Reveal delay={i + 1} key={card.t} className="glow rounded-2xl bg-paper border border-line p-8">
                <span className="inline-flex w-11 h-11 items-center justify-center rounded-xl bg-green-soft text-green">
                  <Icon size={20} strokeWidth={1.7} />
                </span>
                <h3 className="mt-6 font-display text-[19px] font-semibold text-ink tracking-tight">{card.t}</h3>
                <p className="mt-2.5 text-[14px] text-textsoft leading-[1.65]">{card.b}</p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
